import HttpException from 'exceptions/HttpException'

export default class HttpForbiddenException extends HttpException {
  constructor(message, ...args) {
    super('Forbidden', message, ...args)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpForbiddenException)
    }

    this.code = 403
  }
}
